module.exports = __webpack_public_path__ + "static/media/GraviCubeLevelEdit.5af3f45d.png";